import(/* webpackMode: "eager" */ "/home/jetrails/fr.awbridal.com/html/src/app/(app)/template.jsx")